import CheckBoxesListField from './CheckBoxesListField';
import { withListByColumns } from '../../hoc';

import './CheckBoxesListField.scss';

export default withListByColumns(CheckBoxesListField);
